export default {"src":"/_next/static/media/job-thank-you.2065241d.svg","height":167,"width":160,"blurWidth":0,"blurHeight":0};